import React from "react";
import classes from './CashFlowStatement.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import {
    BarChart2,
    Filter,
    CalendarClock,
    Mail,
    ArrowLeft,
    Printer,
    Download,
    Settings
} from 'lucide-react';
import Footer from "../../Components/Footer/Footer";

const CashFlowStatement = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const data = [
        { Invoice: 'Jan 30, 2025', Customer: 'Sales Recipt -invoice#001', InvoiceDate: 'R002', duedate: '#15,200,000.00', originalamount: '--', outstanding: '#15,200,000.00',  },
        { Invoice: 'Jan 30, 2025', Customer: 'Sales Recipt -invoice#001', InvoiceDate: 'R002', duedate: '#15,200,000.00', originalamount: '--', outstanding: '#15,200,000.00',  },
        { Invoice: 'Jan 30, 2025', Customer: 'Sales Recipt -invoice#001', InvoiceDate: 'R002', duedate: '#15,200,000.00', originalamount: '--', outstanding: '#15,200,000.00',  },
        { Invoice: 'Jan 30, 2025', Customer: 'Sales Recipt -invoice#001', InvoiceDate: 'R002', duedate: '#15,200,000.00', originalamount: '--', outstanding: '#15,200,000.00',  },
        { Invoice: 'Jan 30, 2025', Customer: 'Sales Recipt -invoice#001', InvoiceDate: 'R002', duedate: '--', originalamount: '#15,200,000.00', outstanding: '#15,200,000.00',  },
        { Invoice: 'Jan 30, 2025', Customer: 'Sales Recipt -invoice#001', InvoiceDate: 'R002', duedate: '--', originalamount: '#15,200,000.00', outstanding: '#15,200,000.00', },
        { Invoice: 'Jan 30, 2025', Customer: 'Sales Recipt -invoice#001', InvoiceDate: 'R002', duedate: '--', originalamount: '#15,200,000.00', outstanding: '#15,200,000.00', },
        { Invoice: 'Jan 30, 2025', Customer: 'Sales Recipt -invoice#001', InvoiceDate: 'R002', duedate: '#15,200,000.00', originalamount: '--', outstanding: '#15,200,000.00', },
        { Invoice: 'Jan 30, 2025', Customer: 'Sales Recipt -invoice#001', InvoiceDate: 'R002', duedate: '#15,200,000.00', originalamount: '--', outstanding: '#15,200,000.00', },
        { Invoice: 'Total', Customer: '', InvoiceDate: 'R002', duedate: '#15,200,000.00', originalamount: '#15,200,000.00', outstanding: '#15,200,000.00', },

    ];
    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                {/* Action Buttons */}
                <div className={classes.actions}>
                    <button className={classes.btns}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                </div>

                {/* Form and Icons */}
                <div className={classes.act}>
                    <form className={classes.form}>
                        <div className={classes.group}>
                            <label>Period:</label>
                            <div className={classes.dropdownWrapper}>
                                <select className={classes.statusDropdown}>
                                    <option>Current month</option>
                                    <option>Cash</option>
                                    <option>Cheque</option>
                                    <option>Transfer</option>
                                </select>
                                <span className={classes.arrowDown}>▼</span>
                            </div>
                        </div>

                        <div className={classes.group1}>
                            <label>Group by:</label>
                            <div className={classes.dropdownWrapper}>
                                <select className={classes.statusDropdown}>
                                    <option>None</option>
                                    <option>Cash</option>
                                    <option>Cheque</option>
                                    <option>Transfer</option>
                                </select>
                                <span className={classes.arrowDown}>▼</span>
                            </div>
                        </div>

                        <div className={classes.group1}>
                            <button className={classes.greenBtn}>
                                <BarChart2 size={16} style={{ marginRight: "6px" }} />
                                Run Report
                            </button>
                        </div>
                    </form>

                    <div className={classes.iconbars}>
                        <div className={classes.iconbarr}>
                            <div className={classes.iconbar}>
                                <Filter size={16} style={{ marginRight: "6px" }} />
                                Filter
                            </div>
                            <div className={classes.iconbar}>
                                <CalendarClock size={16} style={{ marginRight: "6px" }} />
                                Schedule
                            </div>
                        </div>

                        <div className={classes.iconbarss}>
                            <div className={classes.iconbar}>
                                <Mail size={16} />
                            </div>
                            <div className={classes.iconbar}>
                                <Printer size={16} />
                            </div>
                            <div className={classes.iconbar}>
                                <Download size={16} />
                            </div>
                            <div className={classes.iconbar}>
                                <Settings size={16} />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Back Button */}
                <button className={classes.backButton} onClick={() => navigate(-1)}>
                    <ArrowLeft size={16} style={{ marginRight: '6px' }} />
                    Back to report list
                </button>

                {/* Report Content */}
                <div className={classes.containere}>
                    <header className={classes.headers }>
                        <h1 className={classes.companyName}>Promix Accounting Ltd</h1>
                        <h2 className={classes.title}>Cashflow Statements</h2>
                        <p className={classes.period}>For the period ended January 31, 2025</p>
                        <button className={classes.unaudited}>unaudited</button>
                    </header>

                    <div className={classes.divider}></div>

                    <section className={classes.section}>
                        <div className={classes.row}>
                            <p className={classes.label}> Opening Balance </p>
                            <p className={classes.amount}>N6,200,000.00</p>
                        </div>
                    </section>

                    <div className={classes.tableContainer}>
                                        <table className={classes.table}>
                                            <thead>
                                                <tr className={classes.tableHeader}>
                                                    <th>Date</th>
                                                    <th>Description</th>
                                                    <th>Reference</th>
                                                    <th>Receipt	</th>
                                                    <th>Payment</th>
                                                    <th>Balance</th>
                                                   
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((row, index) => (
                                                    <tr key={index} className={classes.tableRow}>
                                                        <td className={classes.tableCell}>{row.Invoice}</td>
                                                        <td style={{width:'40%'}}className={classes.tableCell}>{row.Customer}</td>
                                                        <td  className={classes.tableCell}>{row.InvoiceDate}</td>
                                                        <td style={{color:'#1ba94c'}}className={classes.tableCell}>{row.duedate}</td>
                                                        <td style={{color:'red'}}className={classes.tableCell3}>{row.originalamount}</td>
                                                        <td className={classes.tableCell}>{row.outstanding}</td>
                                                        {/* <td className={classes.tableCell1}>{row.daysOverdue}</td>
                                                        <td className={classes.tableCell}>
                                                            <span className={`${classes.statusButton} ${classes['status' + row.status]}`}>
                                                                {row.status}
                                                            </span>
                                                        </td> */}
                                                        {/* <td className={classes.tableCell}>{row.action}</td> */}
                                                        {/* <td className={classes.tableCell}>{row.type}</td> */}
                                        
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                    <div className={classes.netProfitRow}>
                        <p className={classes.netProfitLabel}>Closing Balance</p>
                        <p className={classes.netProfitAmount}>N6,050,000.00</p>
                    </div>
                </div>

                 <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <div className={classes.kdpt}>
                                    <p className={classes.kdptg1}>#46,700.00</p>
                                </div>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Opening Balance</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <div className={classes.kdpt}>
                                    <p className={classes.kdptg2}>#147,800.00</p>
                                </div>
                                <div className={classes.rvnue1}>
                                    <p className={classes.skaltxt}>Total Receipt</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frstkad2}>
                            <div className={classes.kad2}>
                                <div className={classes.kdpt}>
                                    <p className={classes.kdptg5}>#3,300,000.00</p>
                                </div>
                                <div className={classes.rvnue2}>
                                    <p className={classes.skaltxt5}>Total Payment</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <div className={classes.kdpt}>
                                    <p className={classes.kdptg4}>#31,200.00</p>
                                </div>
                                <div className={classes.rvnue2}>
                                    <p className={classes.skaltxt}>Opening Balance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                
            </div>
            <Footer />
        </div>
    );
};

export default CashFlowStatement;
